<template>
  <div class="bg" id="wrap">
    <div class="wrap">
      <img src="../../assets/images/market/freetarget/banner.jpg" alt="四维战法-特惠出击_震撼来袭" width="100%" />
      <div class="item item1">
        <ul class="sw-introductions">
          <li>
            黄金波段
            <span>逃顶我行、底部我知</span>
          </li>
          <li>
            黄金狙击
            <span>一击即中，提早狙击变盘窗口</span>
          </li>
          <li>
            智慧动向
            <span>揭秘主力潜伏票</span>
          </li>
          <li>
            市场热度
            <span>热度高低体现盈亏难易</span>
          </li>
        </ul>
        <img src="../../assets/images/market/freetarget/img01.png" alt width="100%" />
        <img src="../../assets/images/market/freetarget/img02.png" alt width="100%" />
      </div>
      <div class="item item2">
        <h2 class="item-title">黄金波段</h2>
        <p>智能标注买卖点，再也不用担心错过赚钱时机啦！</p>
        <img src="../../assets/images/market/freetarget/img04.png" alt width="90%" />
      </div>
      <div class="item item3">
        <h2 class="item-title">智慧动向</h2>
        <p>根据盘中个股量价关系的相关性深度挖掘活跃资金的市场行为。</p>
        <p>跟踪短、中期活跃资金的动向。</p>
        <img src="../../assets/images/market/freetarget/img05.png" alt width="90%" />
      </div>
      <div class="item item4">
        <h2 class="item-title">黄金狙击</h2>
        <p>预示出该股未来短线、中线运行的方向。</p>
        <p>给出较佳的关注点和规避点。</p>
        <img src="../../assets/images/market/freetarget/img06.png" alt width="90%" />
      </div>
      <div class="item item5">
        <h2 class="item-title">市场热度</h2>
        <p>多角度展现市场氛围，不当最后退场者。</p>
        <img src="../../assets/images/market/freetarget/img07.png" alt width="90%" />
      </div>
      <div class="foot">
        <h3>大智慧365功能大集结！</h3>
        <p>功能更丰富，价格不会变！</p>
        <div class="foot-target">
          <div class="foot-target-main">
            特惠
            <strong>998</strong>
          </div>
          <ul class="target-list">
            <li>SV资金流</li>
            <li>慧搜</li>
            <li>Level2</li>
            <li>龙虎榜</li>
            <li>全息盘口</li>
            <li>TS时间序列</li>
            <li>四维战法</li>
          </ul>
        </div>
        <a class="foot-btn" @click="goUrl(116)">全新来袭，立即体验</a>
      </div>
      <div class="side-bar">
        <img
          src="../../assets/images/market/freetarget/side-bar.png"
          alt
          width="100%"
          usemap="#sideBar"
        />
        <map name="sideBar" id="sideBar">
          <area shape="rect" coords="2, 2, 92, 92" target="_bank" @click="goUrl(116)" />
          <area
            shape="rect"
            coords="2, 94, 92, 184"
            href="##2"
            @mouseover="showFun1()"
            @mouseout="hideFun()"
          />
          <area shape="rect" coords="2, 186, 92, 276" href="http://tg.dzh.com.cn/gwhome.php?type=32" />
          <area
            shape="rect"
            coords="2, 278, 92, 368"
            href="##5"
            @mouseover="showFun2()"
            @mouseout="hideFun()"
          />
          <area
            shape="rect"
            coords="7, 370, 87, 460"
            href="javascript:void(0);"
            @click="topFunction"
          />
        </map>
        <div class="code" id="code">
          <img src="../../assets/images/market/freetarget/wechat.png" alt="微信咨询" width="100%" />
        </div>
        <div class="code tel" id="tel">021-20219999</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GiftPages",
  data() {
    return {
      token: "",
    };
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  methods: {
    showFun1() {
      document.getElementById("code").style.display = "block";
    },
    showFun2() {
      document.getElementById("tel").style.display = "block";
    },
    hideFun() {
      document.getElementById("code").style.display = "none";
      document.getElementById("tel").style.display = "none";
    },
    topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
     goUrl (key) {
      let routerDate;
      if (this.token) {
        routerDate = this.$router.resolve({name: 'ClientProduct', query: {token: this.token, pid: key, s: 4}})
      } else {
        routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key}})
      }
      let {href} = routerDate;
      window.open(href, "_blank")
    }
  },
};
</script>

<style scoped>
.bg {
  background: #000005;
}
.wrap {
  width: 1000px;
  margin: 0 auto;
  line-height: 1;
}
.item {
  padding-top: 60px;
  background: #020555;
  position: relative;
}
.item img {
  margin: 0 auto;
  display: block;
}
.sw-introductions {
}
.sw-introductions li {
  font-size: 30px;
  color: #ffe8ca;
  position: absolute;
}
.sw-introductions li span {
  font-size: 24px;
  color: #bebaff;
  display: block;
  margin-top: 12px;
}
.sw-introductions li:nth-of-type(1) {
  left: 156px;
  top: 82px;
}
.sw-introductions li:nth-of-type(2) {
  left: 578px;
  top: 82px;
}
.sw-introductions li:nth-of-type(3) {
  left: 66px;
  top: 260px;
}
.sw-introductions li:nth-of-type(4) {
  left: 692px;
  top: 298px;
}
.item-title {
  display: block;
  background: url("../../assets/images/market/freetarget/img03.png") no-repeat
    center top;
  font-size: 36px;
  line-height: 80px;
  height: 83px;
  color: #61c3ff;
  text-align: center;
  margin-bottom: 60px;
}
.item p {
  color: #b5ddf6;
  font-size: 30px;
  margin: 0 50px 26px;
}
.item p + img {
  margin-top: 60px;
}
.item5 {
  padding-bottom: 55px;
}
.foot {
  background: #172e77;
  padding: 0 0 55px;
  text-align: center;
}
.foot h3 {
  background: url("../../assets/images/market/freetarget/img08.png") no-repeat
    center top;
  font-size: 48px;
  color: #7be5ff;
  line-height: 264px;
  height: 208px;
  text-shadow: 0 4px 0 #4084f1;
}
.foot p {
  color: #96e3f6;
  font-size: 30px;
  margin: 37px auto 58px;
}
.foot-target {
  background: url("../../assets/images/market/freetarget/img09.png") no-repeat
    center top;
  height: 613px;
  position: relative;
  width: 647px;
  margin: 0 auto;
}
.foot-target-main {
  position: absolute;
  top: 230px;
  left: 50%;
  font-size: 36px;
  color: #213775;
  text-align: center;
  width: 230px;
  margin-left: -118px;
}
.foot-target-main strong {
  font-weight: bold;
  font-size: 86px;
  color: #92410a;
  display: block;
  margin-top: 10px;
  letter-spacing: -2px;
}
.foot-btn {
  display: block;
  background: url("../../assets/images/market/freetarget/img10.png") no-repeat
    center top;
  width: 800px;
  height: 100px;
  line-height: 88px;
  font-size: 48px;
  color: #92410a;
  font-weight: bold;
  margin: 90px auto 0;
}
.target-list li {
  position: absolute;
  font-size: 30px;
  color: #ffe8ca;
  width: 220px;
}
.target-list li:nth-of-type(1) {
  top: 80px;
  left: 210px;
}
.target-list li:nth-of-type(2) {
  top: 162px;
  right: 56px;
}
.target-list li:nth-of-type(3) {
  top: 346px;
  right: 0;
}
.target-list li:nth-of-type(4) {
  top: 502px;
  right: 112px;
}
.target-list li:nth-of-type(5) {
  bottom: 80px;
  left: 108px;
}
.target-list li:nth-of-type(6) {
  top: 346px;
  left: 0;
}
.target-list li:nth-of-type(7) {
  top: 162px;
  left: 56px;
}

.side-bar {
  position: fixed;
  top: 50px;
  left: 50%;
  margin-left: 504px;
  width: 94px;
  height: 455px;
  cursor: pointer;
}
area:focus {
  outline: 0;
}
.phoneShow {
  position: absolute;
  color: rgb(255, 255, 255);
  border: 2px solid rgb(64, 152, 224);
  font-size: 15px;
  background: rgb(28, 121, 198);
  line-height: 30px;
  left: -130px;
  bottom: 25px;
  padding: 2px 5px;
  height: 30px;
  width: 111px;
  text-align: center;
  display: none;
}
.code {
  position: absolute;
  right: 97px;
  top: 92px;
  width: 140px;
  border: 2px solid #50a2e3;
  display: none;
}
.tel {
  top: 300px;
  background: #237bc3;
  color: #fff;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/market/FreeTarget.vue